/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { mj_create_unique_id, removeMultipleClasses, toggleMultipleClasses } from './util.js';
import { getFromSession, setInSession } from './session-util.js';
import { mjt } from './i18ntexts.js';



export function disableMediaViewBGCtrlsToolbar( md_trg ) {
	// console.log({w:'bgctrls: disableMediaViewBGCtrlsToolbar',md_trg});
	md_trg.off('.mjMediaViewBGCtrlsToolbar');
}


export function setupMediaViewBGCtrlsToolbar( md_trg, xopts, ontoolbarsetup_cb ) {
	// console.log({w:'bgctrls: setupMediaViewBGCtrlsToolbar',md_trg,xopts});

	function set_bg( level, chessboard, stop ) {
		var c;
		if( chessboard ) {
			if( level < 128 ) {
				c = Math.round( 12 + (level*244.0/128.0) );
				toggleMultipleClasses(md_trg,{'chessboard-lt128':true,'chessboard-ge128':false});
			} else {
				c = Math.round( (level-128)*244.0/128.0 ) - 12;
				toggleMultipleClasses(md_trg,{'chessboard-lt128':false,'chessboard-ge128':true});
			}
		} else {
			c = level;
			removeMultipleClasses(md_trg,['chessboard-lt128','chessboard-ge128']);
		}
		md_trg.css( { backgroundColor:'rgb('+c+','+c+','+c+')' } );
		if( stop ) {
			if( xopts.enable_save_view_session ) {
				const chessboard_on_str = chessboard ? '1' : '0';
				if( getFromSession((xopts.view_session_pfx||'')+'view_bg_level')!=level ) setInSession((xopts.view_session_pfx||'')+'view_bg_level',level);
				if( getFromSession((xopts.view_session_pfx||'')+'view_bg_chessboard')!=chessboard_on_str ) setInSession((xopts.view_session_pfx||'')+'view_bg_chessboard',chessboard_on_str);
			}
		}
	}

	// bind toolbar setup handler - adds custom controls (BG controls)
	md_trg
		.off('.mjMediaViewBGCtrlsToolbar')
		.on( 'mjstoolbarsetup.mjMediaViewBGCtrlsToolbar', function(e,toolbar,is_triggered_here) {
			// console.log({w:'bgctrls: on mjstoolbarsetup',e,toolbar,is_triggered_here});

			if( ontoolbarsetup_cb ) {
				ontoolbarsetup_cb(toolbar);
			}

			if( toolbar==null ) {

				set_bg( getFromSession((xopts.view_session_pfx||'')+'view_bg_level'), getFromSession((xopts.view_session_pfx||'')+'view_bg_chessboard')=='1', false );

			} else {
				$('.md-background-control-elements',toolbar).remove();
				const md_checkerboard_id = mj_create_unique_id('md-checkerboard-');
				$('.left-edge',toolbar).after(
					'<td class="section md-bg-ctrls-1 md-background-control-elements md-preview-ctrl-elems">'
						+ '<span class="label">'+mjt('md-background')+'</span>'
						+ '<span class="slider-icon1 link" tabindex="0"></span>'
						+ '<span class="slider"><div class="ui-slider-handle"></div></span>'
						+ '<span class="slider-icon2 link" tabindex="0"></span>'
					+'</td>'
					+'<td class="separator md-background-control-elements md-preview-ctrl-elems"></td>'
					+'<td class="section md-bg-ctrls-2 md-background-control-elements md-preview-ctrl-elems">'
						+ '<span class="checkerboard"><input type="checkbox" id="'+md_checkerboard_id+'" class="md-checkerboard" value="1" title="'+mjt('md-chessboard')+'" /></span>'
					+'</td>'
					+'<td class="separator md-background-control-elements md-preview-ctrl-elems"></td>'
				);
				const md_checkerboard = $('.md-checkerboard',toolbar);
				const mdt_slider = $('.slider',toolbar);
				// background color slider
				const init_view_bg_level = parseInt(getFromSession((xopts.view_session_pfx||'')+'view_bg_level'),10);
				mdt_slider.slider( {
					value: 255 - init_view_bg_level,
					min: 0,
					max: 255,
					orientation: 'horizontal',
					animate: 'fast',
					slide: function(e,ui) {
						const val = ui.value || $(this).slider('value');
						set_bg( 255-parseInt(val,10), !!md_checkerboard.prop('checked'), false );
					},
					change: function(e,ui) {
						const val = ui.value || $(this).slider('value');
						set_bg( 255-parseInt(val,10), !!md_checkerboard.prop('checked'), true );
					},
				} );
				$('.slider-icon1',toolbar).click( function() {
					mdt_slider.slider('value',mdt_slider.slider('value')-25);
				} );
				$('.slider-icon2',toolbar).click( function() {
					mdt_slider.slider('value',mdt_slider.slider('value')+25);
				} );
				// chessboard switch
				md_checkerboard.click( function() {
					set_bg(255-parseInt(mdt_slider.slider('value'),10),!!$(this).prop('checked'),true);
				} );
				// init widgets from session data
				md_checkerboard.prop('checked',getFromSession((xopts.view_session_pfx||'')+'view_bg_chessboard')=='1');
				// eslint-disable-next-line no-undef
				mdt_slider.slider('value',255-getFromSession((xopts.view_session_pfx||'')+'view_bg_level'));
				// set bg with current state
				set_bg(255-parseInt(mdt_slider.slider('value'),10),!!md_checkerboard.prop('checked'),false);
			}
		} );
}

